import React from 'react';
import './css/share-code.css';
import bj from './image/bj1.jpg';

// document.title = '大师论道';

const Menu4 = () => (
  <div className="menuBackground">
    <img src={bj} alt="bj1" />
    <table>
      <thead>
        <tr>
          <td>名师阵容</td>
          <td>名师介绍</td>
          <td>课程模块</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>戈峻</td>
          <td>天九共享集团全球CEO兼国际集团总裁</td>
          <td>“走出去” 拥抱全球化</td>
        </tr>
        <tr>
          <td>曲敬鲁</td>
          <td>新龙脉资本管理合伙人</td>
          <td>新零售、新连锁的崛起之路</td>
        </tr>
        <tr>
          <td>程俊</td>
          <td>嗖嗖身边创始人兼董事长</td>
          <td>开创互联网实体新时代，推动行业发展</td>
        </tr>
        <tr>
          <td>高建华</td>
          <td>原苹果电脑公司中国市场总监，现任北京洋为中用管理咨询公司首席顾问，企业战略专家</td>
          <td>赢在顶层设计</td>
        </tr>
        <tr>
          <td>杨众筹</td>
          <td>一八九八咖啡董事长</td>
          <td>中国式众筹改造升级传统商业</td>
        </tr>
        <tr>
          <td>陈海良</td>
          <td>天润资本管理有限公司总裁</td>
          <td>天润资本如何为独角兽项目加速赋能</td>
        </tr>
        <tr>
          <td>夏中轩</td>
          <td>天润资本管理有限公司副总裁</td>
          <td>IPO时代，独角兽如何逐鹿资本市场？</td>
        </tr>
        <tr>
          <td>胡宗京</td>
          <td>猪小嫚创始人、资深IP全产业运营专家</td>
          <td>超级IP如何赋能新零售</td>
        </tr>
        <tr>
          <td>李豹</td>
          <td>天九共享网络科技集团CEO</td>
          <td>销售管理的趋势与变革</td>
        </tr>
        <tr>
          <td>李文</td>
          <td>混序部落创始人</td>
          <td>裂变式发展 混序式管理</td>
        </tr>
        <tr>
          <td>张劲</td>
          <td>天九共享平台投资集团CEO</td>
          <td>企业的高效营销系统搭建-支点营销阶梯成交系统</td>
        </tr>
        <tr>
          <td>郭宇宽</td>
          <td>天九独角兽商学院院长</td>
          <td>从鬼谷子看商学院如何培养企业家？</td>
        </tr>
        <tr>
          <td>卢绪文</td>
          <td>天九共享孵化集团高级副总裁、知名时间管理专家</td>
          <td>企业家时间管理</td>
        </tr>
        <tr>
          <td>陈利华</td>
          <td>指尖生活派创始人、董事长兼 CEO</td>
          <td>倡导新生活理念，提升居民幸福感</td>
        </tr>
        <tr>
          <td>钱卫清</td>
          <td>北京大成律师事务所高级合伙人</td>
          <td>幸福一生：企业家的法律智慧</td>
        </tr>
        <tr>
          <td>邓德隆</td>
          <td>特劳特伙伴公司全球总裁、特劳特（中国）董事长</td>
          <td>拥有绝对主导地位的企业才有定价权</td>
        </tr>
        <tr>
          <td>李开复</td>
          <td>创新工场董事长兼首席执行官</td>
          <td>人类和AI将会如何共处</td>
        </tr>
        <tr>
          <td>沈翔</td>
          <td>Cheil鹏泰大中华区首席创意官</td>
          <td>没做到这三点，请你不要做创意！</td>
        </tr>
        <tr>
          <td>李三水</td>
          <td>W创始人</td>
          <td>不做创意人，只做创造者</td>
        </tr>
        <tr>
          <td>周航</td>
          <td>易到用车创始人</td>
          <td>创业就是一场腥风血雨</td>
        </tr>
        <tr>
          <td>鲍艾乐</td>
          <td>拉勾联合创始人</td>
          <td>当我创业时,我做些什么</td>
        </tr>
        <tr>
          <td>卫哲</td>
          <td>嘉御基金创始人、前阿里巴巴B2B CEO</td>
          <td>如何发现雷达以外的投资机会？</td>
        </tr>
        <tr>
          <td>冯卫东</td>
          <td>天图投资管理合伙人、首席投资官</td>
          <td>定位实践4大坑</td>
        </tr>
        <tr>
          <td>周朔</td>
          <td>京润珍珠集团董事总经理</td>
          <td>品牌年轻化无套路</td>
        </tr>
        <tr>
          <td>宁述勇</td>
          <td>沃尔沃企业传播副总裁</td>
          <td>低调中的成长</td>
        </tr>
        <tr>
          <td>于秋涛</td>
          <td>一汽-大众奥迪销售事业部副总经理</td>
          <td>进取之心,造就改变</td>
        </tr>
        <tr>
          <td>陈思英</td>
          <td>北京汽车销售有限公司副总经理</td>
          <td>移动互联时代的营销创新</td>
        </tr>
        <tr>
          <td>陶杨</td>
          <td>贝因美集团副总裁</td>
          <td>品牌态度源于尊重</td>
        </tr>
        <tr>
          <td>段建军</td>
          <td>奔驰销售服务有限公司执行副总裁</td>
          <td>心所向，驰以恒</td>
        </tr>
        <tr>
          <td>程士安</td>
          <td>复旦大学教授&博士生导师</td>
          <td>社会化媒体营销传播的效果评估</td>
        </tr>
        <tr>
          <td>贾伟</td>
          <td>洛可可创新设计集团董事长、洛客共享设计平台创始人</td>
          <td>人人都是设计师,都能创造出对这个世界有价值的产品</td>
        </tr>
        <tr>
          <td>杨飞</td>
          <td>瑞幸咖啡CMO</td>
          <td>中国咖啡的另一个选择</td>
        </tr>
        <tr>
          <td>华杉</td>
          <td>华与华营销咨询有限公司董事长</td>
          <td>品牌的本质</td>
        </tr>
        <tr>
          <td>梁宁</td>
          <td>湖畔大学产品模块学术主任、百度集团顾问、辰德资本创始合伙人、旅人网创始人</td>
          <td>高手与江湖</td>
        </tr>
        <tr>
          <td>维尔纳·法伊曼</td>
          <td>奥地利前总理、社会民主党前主席；现任天九共享控股集团共同主席、天九共享西欧公司联席董事长</td>
          <td>走进死胡同的施华洛世奇，如何成功浴火重生？</td>
        </tr>
        <tr>
          <td>伊夫·莱特姆</td>
          <td>比利时前首相、荷语基督教民主党前主席；现任天九共享控股集团共同主席、天共享九西欧公司董事长</td>
          <td>中小型企业怎样活的更好？重视可持续发展就对了！</td>
        </tr>
        <tr>
          <td>何塞·菲格雷斯</td>
          <td>哥斯达黎加前总统、国家民族解放党前主席；现任天九共享控股集团共同主席、天九共享拉美公司董事长</td>
          <td>哥伦布当年发现的财富新大陆，同样适合中国企业“出海”！</td>
        </tr>
        <tr>
          <td>埃斯科·阿霍</td>
          <td>芬兰国史最年轻的前总理，芬兰最大党派“中间力量党”前主席；现任全球商会联盟共同主席</td>
          <td>管理国家和经营企业，最起码有一点是相通的！</td>
        </tr>
        <tr>
          <td>弗朗索瓦·菲永</td>
          <td>法国前总理、共和党前主席；现任全球商会联盟共同主席</td>
          <td>爱马仕、香奈儿、迪奥、圣罗兰，它们生于法国绝非偶然！</td>
        </tr>
        <tr>
          <td>阿德南·特尔兹奇</td>
          <td>波黑前总理、民主联盟党前主席；现任全球商会联盟高级顾问</td>
          <td>管理国家和经营企业，最起码有一点是相通的！</td>
        </tr>
        <tr>
          <td>托马斯·伊尔韦斯</td>
          <td>爱沙尼亚前总统；现任全球商会联盟共同主席</td>
          <td>战略定位有多重要？国家兴旺、企业发展全靠它！</td>
        </tr>
        <tr>
          <td>亚历山大·克瓦希涅夫斯基</td>
          <td>波兰前总统，著名政治家、经济学家；现任全球商会联盟共同主席</td>
          <td>都说企业发展七分靠打拼，那另外三分靠什么？</td>
        </tr>
        <tr>
          <td>小乔治·帕潘德里欧</td>
          <td>希腊前总理；现任全球商会联盟常务主席</td>
          <td>六任总理之家的传承与创新秘笈，看看能否帮到您？</td>
        </tr>
        <tr>
          <td>尤里·良格</td>
          <td>摩尔多瓦前总理、外交部长、欧洲事务顾问</td>
          <td>中小企业看过来，小国经济创新的秘笈对您同样适用！</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default Menu4;
